<template>
  <div>
    <div class="layout__content__header layout__content__header--white">
      <app-back
        :text="'naDashboard'"
        :route="{
          name: 'dashboard',
          params: {
            customerId: customerId,
            projectId: projectId
          }
        }"
      />
      <h1 class="">
        {{ $t("neviteSiRady") }}
      </h1>
    </div>
    <div class="layout__content__content">
      <div class="mt-5 row">
        <div class="col-sm-12">
          <div v-for="item in items" :key="item.index" class="mb-3">
            <h2>{{ item.nadpis }}</h2>
            <div
              class="mb-2 gray-text text-small font-italic"
              v-html="item.perex"
            />
            <div class="news__item__text" v-html="item.text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Back from "@/components/back.vue";
export default {
  components: {
    "app-back": Back
  },
  data() {
    return {
      items: [],
      loading: false,
      projectId: JSON.parse(localStorage.getItem("selectedProject")).projectId,
      customerId: JSON.parse(localStorage.getItem("selectedCustomer"))
        .customerId
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale() {
      this.loadPosts();
    }
  },
  mounted() {
    this.loadPosts();
  },
  methods: {
    loadPosts() {
      this.items = [];

      this.loading = this.loading ? false : true;
      axios
        .get(process.env.VUE_APP_APICMS + "/" + this.locale + "/article/faq", {
          crossdomain: true
        })
        .then(response => {
          if (typeof response.data == "object") {
            this.items = response.data;
          } else {
            this.items = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.items = [];
        });
    }
  }
};
</script>

<style scoped></style>
